<div class="flex flex-col gap-2">
  @if (loading()) {
    <div class="flex items-center gap-2 px-2 py-3 text-sm text-neutral-400">
      <guarantees-spinner></guarantees-spinner>
      {{ "guaranteeV2.message.searchingDoctors" | translate }}
    </div>
  } @else if (failed()) {
    <guarantees-callout
      tone="warning"
      icon="cloud_off"
      stack
    >
      {{ "guaranteeV2.message.doctorsUnavailable" | translate }}
      <button
        class="self-start rounded-full border border-warning-300 px-2 py-0.5 text-sm font-semibold text-warning-800 hover:bg-warning-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none"
        type="button"
        (click)="retry()"
      >
        {{ "guaranteeV2.action.retry" | translate }}
      </button>
    </guarantees-callout>
  } @else if (empty()) {
    <guarantees-callout
      tone="warning"
      icon="person_off"
    >
      {{ "guaranteeV2.message.noDoctorsAvailable" | translate }}
    </guarantees-callout>
  } @else {
    @if (filterable()) {
      <guarantees-search-field
        icon="person_search"
        name="doctorSearch"
        [ariaLabel]="'guaranteeV2.message.searchDoctorByName' | translate"
        [placeholder]="'guaranteeV2.message.searchDoctorByName' | translate"
        [value]="term()"
        (valueChange)="term.set($event)"
      ></guarantees-search-field>
    }

    @if (noMatches()) {
      <guarantees-callout
        tone="warning"
        icon="search_off"
        stack
      >
        {{ "guaranteeV2.message.noSearchResults" | translate }}
        <button
          class="self-start rounded-full border border-warning-300 px-2 py-0.5 text-sm font-semibold text-warning-800 hover:bg-warning-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none"
          type="button"
          (click)="clearFilter()"
        >
          {{ "guaranteeV2.action.clearSearch" | translate }}
        </button>
      </guarantees-callout>
    } @else {
      <span class="text-sm text-neutral-400">{{ "guaranteeV2.message.doctorsFound" | translate: { count: rows().length } }}</span>

      <ul class="flex max-h-80 flex-col gap-1.5 overflow-y-auto">
        @for (row of rows(); track row.doctor.id) {
          <li>
            <button
              type="button"
              [class]="row.className"
              (click)="chosen.emit(row.doctor)"
            >
              <!-- A face carries a doctor further than any field beside it. -->
              <span class="relative flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary-50 text-sm font-semibold text-primary-700">
                @if (row.photoUrl) {
                  <img
                    class="h-full w-full object-cover"
                    alt=""
                    [src]="row.photoUrl"
                    (error)="photoFailed(row.doctor.id)"
                  />
                } @else {
                  {{ row.initials }}
                }
              </span>

              <span class="flex min-w-0 flex-1 flex-col gap-0.5">
                <span class="min-w-0 truncate text-sm font-semibold text-neutral-700">{{ row.doctor.fullName }}</span>

                <!-- Only what tells one from another: the shared speciality is the list's heading. -->
                <span class="flex min-w-0 flex-wrap items-center gap-x-1.5 text-sm text-neutral-400">
                  @if (showsSpecialization() && row.doctor.specialization) {
                    <span class="min-w-0 truncate">{{ row.doctor.specialization }}</span>
                  }

                  @if (row.doctor.experienceInYears) {
                    <span class="tabular-nums">{{ "guaranteeV2.message.doctorExperienceYears" | translate: { count: row.doctor.experienceInYears } }}</span>
                  }

                  @if (row.doctor.englishSpeaking) {
                    <span class="rounded-full bg-neutral-100 px-1.5 text-neutral-500">{{ "guaranteeV2.label.englishSpeaking" | translate }}</span>
                  }

                  @if (row.doctor.recommended) {
                    <span class="inline-flex items-center gap-0.5 rounded-full bg-primary-50 px-1.5 text-primary-700">
                      <mat-icon class="h-3! w-3! shrink-0 text-xs! leading-3!">verified</mat-icon>
                      {{ "guaranteeV2.message.doctorLiloPick" | translate }}
                    </span>
                  }
                </span>
              </span>

              <!-- A choice, not a way onward: the row states which one is taken. -->
              <mat-icon
                class="h-4! w-4! shrink-0 text-base! leading-4!"
                [class]="row.chosen ? 'text-primary-600' : 'text-neutral-300'"
                >{{ row.chosen ? "check_circle" : "radio_button_unchecked" }}</mat-icon
              >
            </button>
          </li>
        }
      </ul>
    }
  }
</div>
